import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DateTagNotUsedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.numberings.validation.format.date-tag-not-used');
    }
}
